<template>
    <div>
        <Header></Header>
        <div class="main-table">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">就医记录</el-breadcrumb-item>
                <el-breadcrumb-item>检验记录</el-breadcrumb-item>
            </el-breadcrumb>
            <el-table
                    :data="list"
                    stripe
                    size="medium"
                    style="width:100%;margin-top:20px;">
                <el-table-column prop="sqsj" label="检验日期" ></el-table-column>
                <el-table-column prop="bgmc" label="项目名称" ></el-table-column>
                <el-table-column fixed="right" label="操作" width="80">
                    <template slot-scope="scope">
                        <router-link :to="'/jyjl/jyjl-mx/'+from+'/'+id+'/'+scope.row.jybgid"><el-button type="text">明细</el-button></router-link>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    background
                    layout="prev, pager, next ,total"
                    :page-size="pageSize"
                    :total="totalSize"
                    :current-page.sync="currentPage"
                    @current-change="changePage">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import Header from './components/Header.vue'
    import {findJyjlMz,findJyjlZy} from '@/api/biApi.js'
    export default{
        data(){
            return {
                list:[],
                id:'',
                from:'',
                currentPage:1,
                pageSize:15,
                totalSize:0,
            }
        },
        components: {
            Header
        },
        mounted(){
            this.id = this.$route.params.id
            this.from = this.$route.params.from
            if(!this.id || !this.from){
                this.$router.push({ name: '/'})
            }
            if(this.from == 'mz')
                this.getMzJyList(1,this.pageSize)
            if(this.from == 'zy')
                this.getZyJyList(1,this.pageSize)
        },
        methods:{
            getMzJyList(page,size){
                this.currentPage = page
                this.list = [];
                findJyjlMz({
                    "jzlsh":this.id,
                    "size":size,
                    "page":page
                }).then(res=>{
                    if(res && res.list.length > 0){
                        this.list = res.list
                    }
                    this.totalSize = res && res.total ? res.total : 0;
                }).catch(err=>{
                    this.$message.error('获取门诊检验失败');
                })
            },
            getZyJyList(page,size){
                this.currentPage = page
                this.list = [];
                findJyjlZy({
                    "jzlsh":this.id,
                    "size":size,
                    "page":page
                }).then(res=>{
                    if(res && res.list.length > 0){
                        this.list = res.list
                    }
                    this.totalSize = res && res.total ? res.total : 0;
                }).catch(err=>{
                    this.$message.error('获取住院检验失败');
                })
            },
            changePage(page){
                if(this.from == 'mz')
                    this.getMzJyList(page,this.pageSize)
                if(this.from == 'zy')
                    this.getZyJyList(page,this.pageSize)
            },
        }
    }
</script>
<style lang="scss">
    .main-table{
        max-width: 1280px;
        margin:0 auto;
        padding-left:10px;
        padding-right:10px;

        .el-pagination{
            float: right;
            margin: 10px 0px 10px 0px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/pc/jyjl-jyjl.vue